import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';

export enum ButtonLocation {
    ExitIntentPrompt = 'Exit Intent Prompt',
    LDPImageGallery = 'LDP Image Gallery',
    ItemCard = 'Item Card',
    LotTracker = 'Lot Tracker',
}

type TrackItemSavedPayload = TrackingPayload & {
    buttonLocation: ButtonLocation;
    itemId: number;
    lotCategoryLvl1: string;
    lotCategoryLvl2: string;
};

export const trackItemSavedAnalytics = (payload: TrackItemSavedPayload) => {
    track(TrackingEvents.Item.ItemSaved, payload);
};
